import { defineField, defineType } from "sanity";

export type SanctuaryVideoFieldsDetails = {
  videoId: string;
  mimetype: string;
  size: number;
  path: string;
  createdAt: string;
};

export const sanctuaryVideo = defineType({
  type: "object",
  name: "sanctuaryVideo",
  title: "Sanctuary Video",
  fields: [
    defineField({
      name: "videoId",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    }),
    defineField({
      name: "mimetype",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    }),
    // size
    defineField({
      name: "size",
      type: "number",
      validation: (Rule) => Rule.required(),
      readOnly: true
    }),
    // path
    defineField({
      name: "path",
      type: "string",
      validation: (Rule) => Rule.required(),
      readOnly: true
    }),
    // createdAt
    defineField({
      name: "createdAt",
      type: "datetime",
      validation: (Rule) => Rule.required(),
      readOnly: true
    })
  ]
});
